import {PesFormControlType, PesFormModel, TextControlDisplayType} from '@pes/ui';

/**
 * The model used to create the PES login form.
 */
export const PES_LOGIN_MODEL: PesFormModel = {
    name: 'loginForm',
    action: 'on-validated',
    showRequirementInfo: false,
    controls: [
        {
            type: PesFormControlType.TEXT_INPUT,
            name: 'login',
            id: 'login',
            properties: {
                label: 'account.login.login',
                showLabel: true,
                displayType: TextControlDisplayType.TEXT,
                required: true
            }
        },
        {
            type: PesFormControlType.TEXT_INPUT,
            name: 'password',
            id: 'password',
            properties: {
                label: 'account.login.password',
                showLabel: true,
                displayType: TextControlDisplayType.PASSWORD,
                required: true
            }
        },
        {
            type: PesFormControlType.CHECKBOX,
            name: 'rememberMe',
            id: 'rememberMe',
            properties: {
                text: 'account.login.remember_me',
                showLabel: true,
                classList: ['d-none']
            }
        },
        {
            type: PesFormControlType.FORM_LINK,
            name: 'forgotPwdLink',
            id: 'forgotPwdLink',
            properties: {
                label: 'account.login.forget_password',
                classList: ['forget-pwd-link'],
                action: 'observable'
            }
        },
        {
            type: PesFormControlType.FORM_BUTTON,
            name: 'submitButton',
            id: 'submitButton',
            properties: {
                label: 'account.login.connect',
                classList: ['btn-primary'],
                action: 'on-validated'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/app/component/pes-login/login.model.ts